import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import Footer from "../Footer";
import fire from "./Firebase";
import { useReactToPrint } from "react-to-print";
import "../App.css";
import { useNavigate } from "react-router";

function Schooldocument() {
  document.title = "HR School - Certificate";

  const conponentPDF = useRef();
  const conponentPDF2 = useRef();
  const [certificate, setcertificate] = useState({});
  const [comeexcel, setcomeexcel] = useState([]);
  const [comeexcel2, setcomeexcel2] = useState([]);
  useEffect(() => {
    fire.child("certificates").on("value", (data) => {
      if (data.val() == null || data.val() == "") alert("Data Fetch");
      else {
        setcertificate(data.val());
      }
      console.log(data.val());
    });
  }, []);
  useEffect(() => {
    fire.child("excelcerti").on("value", (data) => {
      if (data.val() == null || data.val() == "") alert("Data Fetch");
      else {
        setcomeexcel(data.val());
      }
    });
  }, []);

  useEffect(() => {
    Object.keys(comeexcel).map((data) => {
      setcomeexcel2(comeexcel[data]);
    });
  }, [comeexcel]);
  // const generatePDF = useReactToPrint({
  //   // content: () => conponentPDF.current,
  //   // documentTitle: "Userdata",
  //   // onAfterPrint: () => alert("Data saved in PDF"),
  //   console.log(first)
  // });
  const navigate = useNavigate();
  function generatePDF(keys) {
    sessionStorage.setItem("lastname", keys);
    navigate("/try");
  }
  function generatePDF2(keys) {
    sessionStorage.setItem("lastname2", keys);
    // navigate("/certitry");
  }
  const results = [];

  return (
    <div>
      <Header />
      <center>
        <h1>Download PDF Certificate</h1>
      </center>
      <br />
      <br />
      <div id="maindiv" ref={conponentPDF}>
        {Object.keys(certificate).map((all, index) => {
          return (
            <>
              <div className="print">
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "20px",
                    textalign: "center",
                    border: "10px solid #787878",
                    textTransform:"uppercase"
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      padding: "20px",
                      textalign: "center",
                      border: "5px solid #787878",
                      backgroundColor: "lightsalmon",
                    }}
                  >
                    <center>
                      {" "}
                      <div>HR SCHOOL</div>
                      <hr class="accessory" />
                      <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                        CERTIFICATE OF COMPLETION
                      </span>{" "}
                      <br /> <br />
                      <span style={{ fontSize: "12px" }}>
                        <i>CERTIFIED {certificate[all].Field} SPECIALIST</i>
                      </span>
                      <br />
                      <br />
                      <span style={{ fontSize: "18px" }}>
                        <b>THIS IS TO CERTIFY THAT</b>
                      </span>
                      <br />
                      <br />
                      <span style={{ fontsize: "20px" }}>
                        <b>
                          NAME :- {certificate[all].Gender}{" "}
                          {certificate[all].Name}{" "}
                        </b>
                      </span>{" "}
                      <br />
                      <span style={{ fontsize: "20px" }} class="father">
                        <b>FATHER NAME :- {certificate[all].Father}</b>
                      </span>
                      <br />
                      <span style={{ fontsize: "20px" }}>
                        <b>
                          COURSE DURATION :- {certificate[all].Course} MONTHS
                        </b>
                      </span>{" "}
                      <br />
                      <span style={{ fontsize: "20px" }} class="father">
                        <b>COURSE NAME :- {certificate[all].Coursename}</b>
                      </span>
                      <br />
                      <br />
                      <span style={{ fontsize: "25px" }}>
                        <i>
                          THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN
                          TAKE IT AWAY FROM YOU.
                        </i>
                      </span>
                      <br />
                      <br />
                      <span style={{ fontWeight: "bold" }}>
                        HAS SUCCESSFULLY COMPLETED THE{" "}
                        {certificate[all].Coursename} COURSE WITH HR SCHOOL
                      </span>{" "}
                      <br />
                      <br />
                      <span style={{ fontsize: "20px" }}>
                        WITH SCORE OF <b>{certificate[all].grade}</b>
                      </span>
                      <br /> <br />
                      <span style={{ fontsize: "25px" }}>
                        <i>DATED</i>
                      </span>{" "}
                      <br />
                      <br />
                      <span style={{ fontsize: "30px" }}>
                        START DATE :- {certificate[all].startdate} /
                        {certificate[all].startmonth} /
                        {certificate[all].startyear}
                      </span>{" "}
                      <br />
                      <span style={{ fontsize: "30px" }}>
                        END DATE :- {certificate[all].enddate} /
                        {certificate[all].endmonth}/{certificate[all].endyear}
                      </span>
                      <br />
                      <br />
                      <span style={{ fontsize: "25px" }} class="website">
                        <i>www.hrschool.com</i>
                      </span>
                      <br />
                    </center>
                  </div>
                </div>
                <center>
                  {" "}
                  <br />
                  <button onClick={() => generatePDF(all)}>
                    Download {certificate[all].Name} Image
                  </button>
                </center>
              </div>
            </>
          );
        })}
      </div>
      {comeexcel2.map((all) => {
         return(
          <>
            <div className="print">
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "20px",
                  textalign: "center",
                  border: "10px solid #787878",
                  textTransform:"uppercase"
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "20px",
                    textalign: "center",
                    border: "5px solid #787878",
                    backgroundColor: "lightsalmon",
                  }}
                >
                  <center>
                    {" "}
                    <div>HR SCHOOL</div>
                    <hr class="accessory" />
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                      CERTIFICATE OF COMPLETION
                    </span>{" "}
                    <br />
                    <br />
                    <span style={{ fontSize: "12px" }}>
                      <i>CERTIFIED {all.Field} SPECIALIST</i>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontSize: "18px" }}>
                      <b>THIS IS TO CERTIFY THAT</b>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontsize: "20px" }}>
                      <b>
                        NAME :- {all.Gender}. {all.Name}{" "}
                      </b>
                    </span>{" "}
                    <br />
                    <span style={{ fontsize: "20px" }} class="father">
                      <b>FATHER NAME :- {all.Father}</b>
                    </span>
                    <br />
                    <span style={{ fontsize: "20px" }}>
                      <b>COURSE DURATION :- {all.Course}</b>
                    </span>{" "}
                    <br />
                    <span style={{ fontsize: "20px" }} class="father">
                      <b>COURSE NAME :- {all.Coursename}</b>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontsize: "25px" }}>
                      <i>
                        THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN
                        TAKE IT AWAY FROM YOU.
                      </i>
                    </span>
                    <br />
                    <br />
                    <span style={{ fontWeight: "bold" }}>
                      HAS SUCCESSFULLY COMPLETED THE {all.Coursename} COURSE
                      WITH HR SCHOOL
                    </span>{" "}
                    <br />
                    <br />
                    <span style={{ fontsize: "20px" }}>
                      WITH SCORE OF <b>{all.grade}</b>
                    </span>
                    <br />
                    <span style={{ fontsize: "25px" }}>
                      <i>DATED</i>
                    </span>
                    <br />
                    <span style={{ fontsize: "30px" }}>
                      START DATE :- {all.startdate}/{all.startmonth}/
                      {all.startyear}
                    </span>{" "}
                    <br />
                    <span style={{ fontsize: "30px" }}>
                      END DATE :- {all.enddate}/{all.endmonth}/{all.endyear}
                    </span>
                    <br />
                    <br />
                    <span style={{ fontsize: "25px" }} class="website">
                      <i>www.hrschool.com</i>
                    </span>
                    <br />
                  </center>
                </div>
              </div>
              <center>
                {" "}
                <br />
                <button onClick={() => generatePDF2(all)}>Download {all.Name} Image</button>
              </center>
            </div>
          </>
        );
      })}
      <Footer/>
    </div>
  );
}

export default Schooldocument;
